<template>
  <div>
    <p>
      Phased orbits can be defined using three parameters
      <katex-element expression="N" />, <katex-element expression="P" /> and
      <katex-element expression="Q" /> such that
      <br />
      <katex-element
        expression="T_c = (N \cdot Q + P) T_{mn} = Q \cdot T_{d}"
      />
      <br />
      where <katex-element expression="T_c" /> is the duration of the repeat
      cycle, <katex-element expression="T_{mn}" /> is the mean nodal period and
      <katex-element expression="T_d" /> is the orbital day, which represents
      the revolution period of the planet with respect to the ascending node of
      the orbit.
    </p>
    <p>Additionally, the parameters relate so that:</p>
    <ul>
      <li>
        <katex-element expression="Q = T_c / T_d" /> is the number of planet
        revolutions per repeat cycle.
      </li>
      <li>
        <katex-element expression="N + P/Q = T_d / T_{mn}" /> is the number of
        orbits per orbital day.
      </li>
      <li>
        <katex-element expression="N \cdot Q + P = T_c/T_{mn}" /> is the whole
        number of orbits per repeat cycle.
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'tooltipConstellationGeometrySpacecraft'
}
</script>
